/**
 * Os limites de tamanho dos campos — o ESPELHO do backend.
 *
 * ── Por que é uma cópia, e por que isso é seguro ──────────────────────────
 *
 * A verdade mora em `backend/src/schemas/limites.ts`. Os dois pacotes não
 * compartilham módulo, então este arquivo repete os números — e um teste no
 * backend (`limitesEspelho.test.ts`) LÊ este arquivo e compara. Se divergirem,
 * a suíte quebra.
 *
 * Sem esse teste, a divergência seria silenciosa e cruel: o `maxLength` do
 * input deixaria digitar até 300 enquanto o servidor recusa acima de 200, e a
 * pessoa só descobriria ao clicar em salvar. É a armadilha 5b do handoff com
 * outra roupa — dois números que significam a mesma coisa acabam diferentes.
 *
 * **Ao mudar um número aqui, mude lá também.** O teste avisa, mas avisar
 * depois é pior que lembrar antes.
 */

export const LIMITES = {
  descricao: 200,
  nome: 120,
  textoIa: 500,
  cor: 7,
  data: 10,
  id: 64,
  pisoGlobal: 20000,
  valorMaximo: 1000000000000,
} as const;
